// ResetPassword.js
import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { ReactComponent as LoginIcon } from '../icons/login.svg';
import { ReactComponent as ProchildIcon } from '../icons/prochild.svg';
import { ReactComponent as LockIcon } from '../icons/lock.svg';
import { ReactComponent as CircleIcon } from '../icons/circle.svg';

import styles from './Login&Register.module.css';

import { API_BASE_URL } from './Common';
const resetURL = `${API_BASE_URL}/password-reset`;

function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  //const [successMessage, setSuccessMessage] = useState('');
  const [isReset, setIsReset] = useState(false);
  const [passwordsMatch, setPasswordsMatch] = useState(true);

  useEffect(() => {
    // Validate token or perform any necessary checks here
    // For simplicity, we assume the token is valid
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      setPasswordsMatch(false);
      setError("Verifique os campos errados");
      return;
    }
    if (password.length < 8 || !/\d/.test(password)) {
    // Check for password length and presence of at least 1 number
    setError("A sua password deverá conter pelo menos 8 caracteres e um algarismo");
    return;
  }
    try {
      const response = await axios.post(resetURL, { token, password });
      // Assuming the response contains a success message upon successful password reset
      //setSuccessMessage(response.data.message);
      setIsReset(true);
    } catch (error) {
      //setError(error.response.data.message);
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (confirmPassword && e.target.value !== confirmPassword) {
      setPasswordsMatch(false);
    } else {
      setPasswordsMatch(true);
    }
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    if (password && e.target.value !== password) {
      setPasswordsMatch(false);
    } else {
      setPasswordsMatch(true);
    }
  };

  return (
    <div className={styles.recoveryContainer}>
    <LoginIcon className={styles.loginIcon2}/>

    {isReset ? <CircleIcon className={styles.keyIcon}/> : <LockIcon className={styles.keyIcon}/>}

    <div className={styles.bigText2}>
      Redefinir password
      </div>

    <div className={styles.welcomeText2}>

      {isReset ? (
  <>
    A sua password foi redefinida com sucesso!
    <br />
    Clique abaixo para fazer login.
  </>
)  : 'A sua password deverá ser diferente das anteriores e deverá conter pelo menos 8 caracteres e um algarismo.'}
      </div>
 {!isReset && (
      <form onSubmit={handleSubmit} className={styles.recoveryForm}>
        <div className={styles.formGroup}>
          <label>Password</label>
          <input
          placeholder="Inserir password"
          type="password" value={password}
          onChange={handlePasswordChange}
          required />
        </div>
        <div className={styles.formGroup}>
          <label>Confirmar password</label>
          <input
          className={!passwordsMatch ? styles.inputError : ''}
          placeholder="Inserir password"
          onChange={handleConfirmPasswordChange}
          type="password" value={confirmPassword}
          required />
        </div>

        {error && <p className={styles.welcomeText2} style={{ color: '#F70404' }}>{error}</p>}
{/*        {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
*/}
        <button type="submit" className={styles.loginBtn}>Redefinir password</button>
      </form>
)}

{isReset && (
  <div className={styles.recoveryForm2}>

  <Link to="/">
        <button
          className={styles.loginBtn}
        >
          Login
        </button>
    </Link>
      </div>
)}

      <div className={styles.linkContainer}>
      <ProchildIcon className={styles.loginIcon3}/>
      </div>
    </div>
  );
}

export default ResetPassword;
